import { z } from 'zod';

export const zodInvoiceProcessFromInvoiceIdsParamsSchema = z.object({
  invoiceId: z.array(z.uuid()),
});

export const zodInvoiceProcessFromInvoiceIdsItemSchema = z.object({
  invoiceDate: z.string(),
  invoiceId: z.uuid(),
  invoiceNr: z.string(),
  ivProcessId: z.uuid(),
});

export const zodInvoiceProcessFromInvoiceIdsResponseSchema = z.array(
  zodInvoiceProcessFromInvoiceIdsItemSchema,
);
